import { makeStyles } from '@surveycake/rc';

export const usePaginationStyles = makeStyles([
  [
    'pagination',
    `	:lang(ar){
			transform: scaleX(-1);
		}
		display: flex;
		align-items: center;
	`
  ]
]);

export const useArrowStyles = makeStyles([
  [
    'arrow',
    (theme, [disabled]) => [
      `
			display: inline-block;
			width: 46px;
			height: 36px;
			font-size: 36px;
			line-height: 36px;
			background-color: ${theme.color.text.F};
			border-radius: 4px;
			color: ${theme.color.primary.default};
			margin: 0 4px;
			text-align: center;
			vertical-align: middle;
			transition: background-color 0.3s ease, opacity 0.3s ease;
			cursor: pointer;
		`,
      !disabled &&
        `
			&:hover,
			&:focus,
			&:active {
				background-color: ${theme.survey.color.light};
			}
		`,
      disabled &&
        `
			opacity: 0.4;
			cursor: not-allowed;
		`
    ]
  ]
]);
